module.exports = __webpack_public_path__ + "static/media/package-4.f2c8a1ab.jpg";